import React, { useCallback, useEffect, useRef, useState } from "react";
import { get_client_feed_and_job } from "../../../DAL/clientTypes/ClientTpes";
import { useParams } from "react-router-dom";
import { enqueueSnackbar } from "notistack";
import { CircularProgress, IconButton } from "@mui/material";
import CircularLoader from "../../../components/loader/CircularLoader";
import RecordNotFound from "../../../components/recordNotFound/RecordNotFound";
import PostCard from "../../../components/cards/PostCard";
import JobListCard from "../../../components/jobs/JobListCard";
import ClientsJobCard from "./ClientsJobCard";
import { useIds } from "../../../hook/AdminContext";
import UpgradeModal from "../../../components/popUp/UpgradeModal";
import CreatePost from "../../post/CreatePost";
import Candidates2 from "../../jobsCandidate/Candidates";
import { ArrowBack } from "@mui/icons-material";
import PostJobDetails from "../../post/PostJobDetails";
import RecordNoImage from "../../../components/recordNotFound/RecordNoImage";
import PostSwiper from "../../../components/CustomSwiper/PostSwiper";
import CustomPagination from "../../../components/CustomPagination/CustomPagination";

export default function ClientsJobAndFeedListing({
  type = "feed",
  clientId,
  handleBack,
  handleMoveJobCandidates = () => {},
  handleMoveJobDetails = () => {},
  jobCardToOpen = "list",
  targetJob = null,
  setJobCardToOpen = () => {},
}) {
  const params = useParams();
  const { userInfo, setUpdateJobOnNotification } = useIds();
  const sourceSlug = params?.source_slug || "";
  const [listing, setListing] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isTypeChanged, setIsTypeChanged] = useState(false);
  let isTablet = window.innerWidth > 768;

  const [openUpgradeModal, setOpenUpgradeModal] = useState(false);

  const [pageNumber, setPageNumber] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

  // edit feed states
  const [formAction, setFormAction] = useState("EDIT");
  const [selectedFeed, setSelectedFeed] = useState(null);
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [previewLink, setPreviewLink] = useState(true);
  const [feedType, setFeedType] = useState("");

  const handleFeedEdit = (selected_feed) => {
    if (
      (userInfo.membership_type !== "free" && !userInfo?.has_transactions) ||
      !userInfo.status
    ) {
      setOpenUpgradeModal(true);
      return;
    }

    setFormAction("EDIT");
    setSelectedFeed(selected_feed);
    setOpenCreateModal(true);
  };

  const handleGetClientJobAndFeedListing = async () => {
    setLoading(true);
    const resp = await get_client_feed_and_job(
      clientId,
      type,
      "",
      pageNumber,
      10
    );
    if (resp.code == 200) {
      if (isLoadingMore) {
        let newArray = listing.concat(resp?.data?.data || []);
        setListing(newArray);
      } else {
        setListing(resp?.data?.data);
      }
      setTotalPages(resp?.data?.total_page);
    } else {
      enqueueSnackbar(resp.message, { variant: "error" });
      setListing([]);
    }
    setLoading(false);
    setIsLoadingMore(false);
  };

  useEffect(() => {
    setLoading(true);
    setPageNumber(0);
    setIsTypeChanged((prev) => !prev);
  }, [type]);

  useEffect(() => {
    handleGetClientJobAndFeedListing();
  }, [pageNumber, isTypeChanged]);

  const handleSelectedImage = (post, index) => {
    setSelectedIndex(index);
  };

  const observer = useRef();

  const lastBookElementRef = useCallback(
    (node) => {
      if (isLoadingMore) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && totalPages > pageNumber) {
          setPageNumber(pageNumber + 1);
          setIsLoadingMore(true);
        }
      });
      if (node) observer.current.observe(node);
    },
    [isLoadingMore, totalPages, pageNumber, observer]
  );

  const handleUpdateSpecificJob = (updatedJob, setList = setListing) => {
    if (updatedJob.deleted_job_id) {
      setList((prev) =>
        prev.filter((item) => item._id != updatedJob.deleted_job_id)
      );
      return;
    }
    setList((prev) =>
      prev.map((item) =>
        item._id === updatedJob._id ? { ...item, ...updatedJob } : item
      )
    );
  };

  useEffect(() => {
    // Register the function
    if (type == "job") {
      setUpdateJobOnNotification((data) => {
        handleUpdateSpecificJob(data, setListing);
      });
    }
    // Cleanup: reset function on unmount
    return () => {
      setUpdateJobOnNotification(() => {});
    };
  }, [listing, type]);

  return (
    <>
      {openUpgradeModal && (
        <UpgradeModal
          open={openUpgradeModal}
          handleClose={() => setOpenUpgradeModal(false)}
        />
      )}

      {((userInfo?.role == "client" && !userInfo?.isCompanyProfile) ||
        (userInfo?.isCompanyProfile &&
          (userInfo?.company_access?.feed?.add ||
            userInfo?.company_access?.feed?.update))) && (
        <>
          {openCreateModal && (
            <CreatePost
              setFeedType={setFeedType}
              feedType={feedType}
              openCreateModal={openCreateModal}
              setOpenCreateModal={setOpenCreateModal}
              userInfo={userInfo}
              getFeedsListing={(url, feed) => {
                if (formAction == "EDIT") {
                  setListing((prev) => {
                    return prev.map((obj) => {
                      if (obj._id === selectedFeed._id) {
                        return feed;
                      }
                      return obj;
                    });
                  });
                }
              }}
              selectedFeed={selectedFeed}
              type={formAction}
              setFormAction={setFormAction}
              previewLink={previewLink}
              setPreviewLink={setPreviewLink}
            />
          )}
        </>
      )}

      <div className="w-100">
        {type == "job" &&
        (jobCardToOpen == "candidate_list" ||
          jobCardToOpen == "ideal_candidate_list") ? (
          ""
        ) : (
          <div className="d-flex justify-content-between align-items-start">
            {/* JOB DETAILS */}
            {type === "job" && jobCardToOpen === "job_details" && (
              <span className="tw-mb-3 profile-section-heading">
                <IconButton
                  className="me-1"
                  size="small"
                  onClick={() => handleBack("job")}
                >
                  <ArrowBack fontSize="small" />
                </IconButton>
                Job Details{" "}
                <span style={{ fontWeight: "normal", fontSize: "14px" }}>
                  ({targetJob?.job_title || "N/A"})
                </span>
              </span>
            )}

            {/* FEED */}
            {type === "feed" && <></>}

            {/* JOBS (default) */}
            {type !== "feed" &&
              !(type === "job" && jobCardToOpen === "job_details") && (
                <span className="tw-mb-3 profile-section-heading">Jobs</span>
              )}
          </div>
        )}
        {loading ? (
          <CircularLoader />
        ) : (
          <>
            {(type == "feed" || (type == "job" && jobCardToOpen == "list")) && (
              <>
                {listing && listing.length > 0 ? (
                  type == "feed" ? (
                    <div>
                      {listing.map((post) => (
                        <PostCard
                          key={post?._id}
                          post={post}
                          handleFeedEdit={handleFeedEdit}
                          formAction={"EDIT"}
                          handleSelectedImage={handleSelectedImage}
                          getFeedsListingOnDelete={() => {
                            setListing((prev) =>
                              prev.filter((item) => item._id !== post._id)
                            );
                          }}
                          selectedIndex={selectedIndex}
                          setSelectedIndex={setSelectedIndex}
                          feedsList={listing}
                          type={"EDIT"}
                        />
                      ))}
                    </div>
                  ) : (
                    listing.map((post) => (
                      <ClientsJobCard
                        job={post}
                        setJobsList={setListing}
                        isTablet={isTablet}
                        setListing={setListing}
                        handleMoveJobCandidates={handleMoveJobCandidates}
                        handleMoveJobDetails={handleMoveJobDetails}
                      />
                    ))
                  )
                ) : (
                  <div className="mt-5">
                    <RecordNoImage
                      title={`${type == "feed" ? "Feed" : "Jobs"} Not Found`}
                    />
                  </div>
                )}
                {/* {!loading && totalPages > pageNumber && listing.length > 0 && (
                  <div className="col-12 text-center mt-3">
                    <div
                      ref={lastBookElementRef}
                      className="mt-3"
                      onClick={() => {
                        setPageNumber(pageNumber + 1);
                      }}
                      id="load-more-feed"
                    >
                      {isLoadingMore ? (
                        <CircularProgress size={15} />
                      ) : (
                        "Load More"
                      )}
                    </div>
                  </div>
                )} */}

                <CustomPagination
                  totalPages={totalPages}
                  page={pageNumber + 1}
                  onPageChange={(value) => {
                    console.log(value);
                    setPageNumber(value - 1);
                  }}
                />
              </>
            )}

            {type == "job" && jobCardToOpen == "candidate_list" && (
              <Candidates2
                jobId={targetJob._id}
                isClientDetailsFlow={true}
                handleBack={handleBack}
                setJobCardToOpen={setJobCardToOpen}
              />
            )}
            {type == "job" && jobCardToOpen == "ideal_candidate_list" && (
              <Candidates2
                jobId={targetJob._id}
                isClientDetailsFlow={true}
                handleBack={() => {
                  setJobCardToOpen("candidate_list");
                }}
                isOpenInIdealCandidate={true}
              />
            )}
            {type == "job" && jobCardToOpen == "job_details" && (
              <PostJobDetails
                targetJob={targetJob}
                isClientDetailsFlow={true}
                handleBack={() => {
                  handleBack();
                  setLoading(true);
                  setPageNumber(0);
                  setIsTypeChanged((prev) => !prev);
                }}
              />
            )}
          </>
        )}
      </div>
    </>
  );
}
